// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"Watermark_textContainer__GnOVt","waterMarkText":"Watermark_waterMarkText__7qZlp","skeleton-loading":"Watermark_skeleton-loading__4JZAL"};